import {IExchange} from '../../../types/models/Exchange';
import {
  ExchangesActionTypes,
  FETCH_EXCHANGES_DATA,
  FETCH_EXCHANGES_DATA_ERROR,
  FETCH_EXCHANGES_DATA_SUCCESS,
  UPDATE_EXCHANGES_DATA,
} from '../../../types/actions/Exchanges/Exchanges.action';

export interface ExchangesState {
  data: IExchange[];
  isLoading: boolean;
}

const initialExchanges: ExchangesState = {
  data: [],
  isLoading: true,
};

export default (state = initialExchanges, action: ExchangesActionTypes) => {
  switch (action.type) {
    case FETCH_EXCHANGES_DATA:
      return {...state, isLoading: true};

    case FETCH_EXCHANGES_DATA_SUCCESS:
      return {...state, isLoading: false, data: action.payload};

    case FETCH_EXCHANGES_DATA_ERROR:
      return {...state, isLoading: false};

    case UPDATE_EXCHANGES_DATA: {
      const index = state.data.findIndex(
        ({slug}) => slug === action.payload.slug,
      );
      if (index !== -1) {
        const newData = [...state.data];
        newData[index].price = action.payload.last;
        return {...state, data: newData};
      }
      return state;
    }

    default:
      return state;
  }
};
